module.exports = __webpack_public_path__ + "img/consulting.c36af526.png";